// Grey cards standing for the cards of a list on a phone while it is read.
const MobileListSkeleton = ({ count = 5 }) => (
  <div className="flex flex-col gap-3 p-4" aria-busy="true">
    {Array.from({ length: count }, (_, index) => (
      <div key={index} className="rounded-xl border border-gray-200 bg-white p-4">
        <div className="mb-3 h-5 w-3/4 skeleton-bar" />
        <div className="flex items-center justify-between">
          <div className="h-4 w-24 skeleton-bar" />
          <div className="h-4 w-28 skeleton-bar" />
        </div>
      </div>
    ))}
  </div>
);

export default MobileListSkeleton;
